<template>
  <icon-button
    data-cy="attach-file-button"
    :icon="IconAttach"
    @click="isModalOpen = true"
  />
  <lf-modal
    v-if="isModalOpen"
    :title="$t('DEALS.DOCUMENTS.ATTACH_DOCUMENTS')"
    :close="() => (isModalOpen = false)"
    small
  >
    <template #content>
      <div class="flex h-[calc(100%-52px)] flex-col items-stretch">
        <upload-box
          class="call-log"
          data-cy="upload-call-recording"
          :accept="accept"
          :type="UploadBoxType.Email"
          @files:add="handleAttachFile"
        />
      </div>
    </template>
  </lf-modal>
</template>

<script setup lang="ts">
import { ref } from "vue";

import { UploadBoxType } from "@/enums/files";

import IconAttach from "@/components/icons/IconAttach.vue";
import LfModal from "@/components/ui/Modal.vue";
import IconButton from "@/components/ui/buttons/IconButton.vue";
import UploadBox from "@/components/ui/inputs/UploadBox.vue";

const ACCEPT = ".doc, .docx, .gif, .heic, .jpg, .pdf, .png, .xls, .xlsx";

const { accept = ACCEPT } = defineProps<{
  accept?: string;
}>();

const emit = defineEmits(["attach-file"]);

const isModalOpen = ref(false);

const handleAttachFile = (files: FileList) => {
  emit("attach-file", files);
  isModalOpen.value = false;
};
</script>
